import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { AlertTriangle, ShieldAlert, Home, ArrowLeft } from 'lucide-react';

export function NotFoundPage({ isEn }) {
  const seoTitle = isEn ? '404 - Page Not Found | Fredericia Isolerings-puder' : '404 - Siden blev ikke fundet | Fredericia Isolerings-puder';
  
  return (
    <>
      <Helmet>
        <title>{seoTitle}</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>

      <section className="py-24 sm:py-32 bg-brand-dark min-h-[70vh] flex items-center justify-center relative overflow-hidden">
        <div className="absolute inset-0 bg-[linear-gradient(to_right,#1f2937_1px,transparent_1px),linear-gradient(to_bottom,#1f2937_1px,transparent_1px)] bg-[size:4rem_4rem] opacity-10" />
        
        <div className="max-w-md mx-auto px-4 text-center space-y-6 relative z-10">
          <div className="inline-flex items-center justify-center h-16 w-16 rounded-full bg-brand-accent/10 text-brand-accent border border-brand-accent/20 mb-2">
            <AlertTriangle className="h-8 w-8" />
          </div>
          
          <h1 className="text-4xl font-display font-bold text-white tracking-tight">
            404
          </h1>
          
          <h2 className="text-xl font-display font-bold text-gray-200">
            {isEn ? 'Page Not Found' : 'Siden blev ikke fundet'}
          </h2>
          
          <p className="text-gray-400 text-sm leading-relaxed">
            {isEn 
              ? 'The page you are looking for might have been removed, had its name changed, or is temporarily unavailable.'
              : 'Siden, du leder efter, findes ikke. Den kan være blevet slettet, have fået ændret navn eller være midlertidigt utilgængelig.'}
          </p>

          <div className="pt-4 flex flex-col sm:flex-row gap-3 justify-center">
            <Link
              to={isEn ? '/en' : '/'}
              className="bg-brand-accent hover:bg-brand-accent-hover text-white font-medium px-5 py-2.5 rounded text-sm transition-colors flex items-center justify-center gap-2 shadow-lg shadow-brand-accent/10"
            >
              <Home className="h-4 w-4" />
              {isEn ? 'Go to Homepage' : 'Gå til forsiden'}
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}

export function ForbiddenPage({ isEn }) {
  const seoTitle = isEn ? '403 - Access Forbidden | Fredericia Isolerings-puder' : '403 - Adgang nægtet | Fredericia Isolerings-puder';

  return (
    <>
      <Helmet>
        <title>{seoTitle}</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>

      <section className="py-24 sm:py-32 bg-brand-dark min-h-[70vh] flex items-center justify-center relative overflow-hidden">
        <div className="absolute inset-0 bg-[linear-gradient(to_right,#1f2937_1px,transparent_1px),linear-gradient(to_bottom,#1f2937_1px,transparent_1px)] bg-[size:4rem_4rem] opacity-10" />
        
        <div className="max-w-md mx-auto px-4 text-center space-y-6 relative z-10">
          <div className="inline-flex items-center justify-center h-16 w-16 rounded-full bg-red-500/10 text-red-500 border border-red-500/20 mb-2">
            <ShieldAlert className="h-8 w-8" />
          </div>
          
          <h1 className="text-4xl font-display font-bold text-white tracking-tight">
            403
          </h1>
          
          <h2 className="text-xl font-display font-bold text-gray-200">
            {isEn ? 'Access Forbidden' : 'Adgang nægtet'}
          </h2>
          
          <p className="text-gray-400 text-sm leading-relaxed">
            {isEn 
              ? 'You do not have permission to access this resource. If you believe this is an error, please contact support.'
              : 'Du har ikke adgang til denne ressource. Hvis du mener, at dette er en fejl, bedes du kontakte support.'}
          </p>

          <div className="pt-4 flex flex-col sm:flex-row gap-3 justify-center">
            <Link
              to={isEn ? '/en' : '/'}
              className="bg-brand-accent hover:bg-brand-accent-hover text-white font-medium px-5 py-2.5 rounded text-sm transition-colors flex items-center justify-center gap-2 shadow-lg shadow-brand-accent/10"
            >
              <Home className="h-4 w-4" />
              {isEn ? 'Go to Homepage' : 'Gå til forsiden'}
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}
